/**
 * Display label for Profile → Team roster role values (`developer`, `qa`, custom names).
 * Matches `<select>` option text in ProfilePage (Dev / QA / …).
 */
export function formatTeamRosterRoleDisplay(role: string): string {
  const raw = role.trim();
  if (!raw) return '';
  const r = raw.toLowerCase();
  if (r === 'qa') return 'QA';
  if (r === 'developer' || r === 'dev') return 'Dev';
  if (r === 'design') return 'Design';
  if (r === 'manager') return 'Manager';
  return raw;
}
